/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MarkInvoiceSettlementResult } from "./MarkInvoiceSettlementResult";
import {
  MarkInvoiceSettlementResultFromJSON,
  MarkInvoiceSettlementResultFromJSONTyped,
  MarkInvoiceSettlementResultToJSON,
  MarkInvoiceSettlementResultToJSONTyped,
} from "./MarkInvoiceSettlementResult";

/**
 *
 * @export
 * @interface MarkInvoicesSettlementPendingBulkResponse
 */
export interface MarkInvoicesSettlementPendingBulkResponse {
  /**
   *
   * @type {string}
   * @memberof MarkInvoicesSettlementPendingBulkResponse
   */
  batchId: string;
  /**
   *
   * @type {Array<MarkInvoiceSettlementResult>}
   * @memberof MarkInvoicesSettlementPendingBulkResponse
   */
  results: Array<MarkInvoiceSettlementResult>;
}

/**
 * Check if a given object implements the MarkInvoicesSettlementPendingBulkResponse interface.
 */
export function instanceOfMarkInvoicesSettlementPendingBulkResponse(
  value: object,
): value is MarkInvoicesSettlementPendingBulkResponse {
  if (!("batchId" in value) || value["batchId"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function MarkInvoicesSettlementPendingBulkResponseFromJSON(
  json: any,
): MarkInvoicesSettlementPendingBulkResponse {
  return MarkInvoicesSettlementPendingBulkResponseFromJSONTyped(json, false);
}

export function MarkInvoicesSettlementPendingBulkResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MarkInvoicesSettlementPendingBulkResponse {
  if (json == null) {
    return json;
  }
  return {
    batchId: json["batchId"],
    results: (json["results"] as Array<any>).map(
      MarkInvoiceSettlementResultFromJSON,
    ),
  };
}

export function MarkInvoicesSettlementPendingBulkResponseToJSON(
  json: any,
): MarkInvoicesSettlementPendingBulkResponse {
  return MarkInvoicesSettlementPendingBulkResponseToJSONTyped(json, false);
}

export function MarkInvoicesSettlementPendingBulkResponseToJSONTyped(
  value?: MarkInvoicesSettlementPendingBulkResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    batchId: value["batchId"],
    results: (value["results"] as Array<any>).map(
      MarkInvoiceSettlementResultToJSON,
    ),
  };
}
